import { AuthService } from '@customer-frontend/auth';
import { logger } from 'utils/logging';

export const authService = new AuthService(
  'auth-token',
  'user',
  'local_storage',
  logger,
);
